import React, { useEffect, useState } from 'react';

import Dede from '../languages/de-de.json';
import Enau from '../languages/en-au.json';
import Enca from '../languages/en-ca.json';
import Engb from '../languages/en-gb.json';
import Ensg from '../languages/en-sg.json';
import Enus from '../languages/en-us.json';
import Eses from '../languages/es-es.json';
import Esmx from '../languages/es-mx.json';
import Frca from '../languages/fr-ca.json';
import Frfr from '../languages/fr-fr.json';
import { IntlProvider } from 'react-intl';
import Itit from '../languages/it-it.json';
import Jajp from '../languages/ja-jp.json';
import Kokr from '../languages/ko-kr.json';
import { LANGUAGES } from '../utils/constants';
import Plpl from '../languages/pl-pl.json';
import Ptbr from '../languages/pt-br.json';
import Ruru from '../languages/ru-ru.json';
import Thth from '../languages/th-th.json';
import Zhcn from '../languages/zh-cn.json';
import Zhtw from '../languages/zh-tw.json';
import { getBrowserLocaleFromIp } from '../utils/localeDetector';
import { selectLocalSettings } from '../ducks/settings';
import { useSelector } from 'react-redux';

const messages: any = {
  'en-ca': Enca,
  'fr-ca': Frca,
  'de-de': Dede,
  'en-gb': Engb,
  'es-es': Eses,
  'fr-fr': Frfr,
  'it-it': Itit,
  'pl-pl': Plpl,
  'ru-ru': Ruru,
  'pt-br': Ptbr,
  'en-us': Enus,
  'es-mx': Esmx,
  'th-th': Thth,
  'en-au': Enau,
  'en-sg': Ensg,
  'zh-tw': Zhtw,
  'zh-cn': Zhcn,
  'ja-jp': Jajp,
  'ko-kr': Kokr
};

type Props = React.HTMLAttributes<HTMLInputElement>;

const LanguageProvider = (props: Props) => {
  const languageLocal = useSelector(selectLocalSettings);
  const [locale, setLocale] = useState<string>(LANGUAGES[0].locale);

  useEffect(() => {
    const updateLocale = async () => {
      setLocale(languageLocal || (await getBrowserLocaleFromIp()));
    };
    updateLocale();
  }, [languageLocal]);

  return (
    <IntlProvider locale={locale} messages={messages[locale]} key={locale}>
      {props.children}
    </IntlProvider>
  );
};

export default LanguageProvider;
